import { merge } from 'lodash';
import { EventPricingLineItem } from '../services';
import { DatabaseEventCourseRun } from '../types';

export function priceMapper(
  databaseEventCourseRuns: DatabaseEventCourseRun[],
  pricing: EventPricingLineItem[],
) {
  const courseRuns: DatabaseEventCourseRun[] = [];

  const pricingByProductId: { [productId: string] : EventPricingLineItem } = {};

  for (const item of pricing) {
    const { sansProductId } = item;
    pricingByProductId[sansProductId] = item;
  }

  for (const databaseEventCourseRun of databaseEventCourseRuns) {
    const price = pricingByProductId[databaseEventCourseRun.event_product_id];

    //update course run price if it exists and add salesforce attributes
    if (price) {
      const sf_map = {
        pricing: price.listPrice,
        public_od_bundle: price.addons?.onDemandPrice ? price.addons.onDemandPrice : null,
        public_giac_bundle: price.addons?.certificationPrice ? price.addons.certificationPrice : null,
        salesforce: price,
      };
      merge(databaseEventCourseRun, sf_map);
    }

    //check if it has a linked run
    const linkedRun = databaseEventCourseRun.linked_run;
    if (linkedRun) {
      const prefixKey = (linkedRun.override_linked_modality_code) ? 'override_' : 'linked_';
      const linkedEventProductId = linkedRun[`${prefixKey}event_product_id`];
      const linkedRunPrice = linkedEventProductId ? pricingByProductId[linkedEventProductId] :false;
      //if it has a salesforce entry update linked course run
      if (linkedRunPrice) {
        merge(databaseEventCourseRun.linked_run, {
          salesforce: linkedRunPrice,
          pricing: linkedRunPrice.listPrice,
        });
      }
    }

    courseRuns.push(databaseEventCourseRun);
  }

  return courseRuns;
}
